// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"133":"98f9c55e","583":"a8cb66ec","789":"f4ee0f9a"}[chunkId] + ".chunk.css";
};